import { Injectable } from '@angular/core';

import { ProductCushionSpec } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ProductCushionSpecService extends TmsWebBaseEditService<ProductCushionSpec, ProductCushionSpec> {
  constructor() {
    super('CushionSpec', $localize`Cushion Spec`);
  }
}
